import { AbstractControl, ValidationErrors } from "@angular/forms";

export function FacebookUrlValidator(
    control: AbstractControl
): ValidationErrors | null {
    if (!control.value) {
        return null;
    }
    
    const facebookRegex = /^(https?:\/\/)?(www\.|m\.)?facebook\.com\/.+$/i;

    const isValid = facebookRegex.test(control.value.trim());

    return isValid ? null : { invalid: true };
}
